import React from 'react';

export const ArrowDown = () => {
  return (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.5" d="M13.5638 2.37414C13.8461 2.11557 14 1.78648 14 1.39863C14 0.622919 13.3329 0 12.4863 0C12.0629 0 11.6781 0.164545 11.383 0.434868L6.98717 4.65034L2.61698 0.434868C2.32193 0.164545 1.92425 0 1.51374 0C0.667074 0 0 0.622919 0 1.39863C0 1.78648 0.15394 2.11557 0.436164 2.37414L5.80696 7.50637C6.1405 7.83546 6.55101 7.98825 7 8C7.44899 8 7.83384 7.83546 8.18021 7.50637L13.5638 2.37414Z" fill="white"/>
    </svg>
  )
}
